module.exports = __webpack_public_path__ + "img/icon-zhedie.288d40be.svg";